import { ItemOrQuantityIssueTypeDomestic } from '../../../../enums';

export interface IQuantitySubtypeDom {
    issueType: ItemOrQuantityIssueTypeDomestic;
    unorderedItemQuantity?: number;
    unorderedItemSmn?: string;
}
